var _rect, _rect2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTenbisCardIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 20,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 25.5,
  height: 18.5,
  x: 0.75,
  y: 0.75,
  fill: "#fff",
  rx: 2.25
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 25.5,
  height: 18.5,
  x: 0.75,
  y: 0.75,
  stroke: "#F36805",
  strokeWidth: 1.5,
  rx: 2.25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F36805",
  d: "M26.312 15 .688 13.256V1.416h25.625z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tenbisCardIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M13.353 3.413s.246-.178.523 0c0 0 .628.383 1.155.822 0 0 .1.068.103-.048 0 0-.016-.342.025-.45 0 0 .049-.142.193-.137 0 0 .452.023.742.06 0 0 .2.021.234.252 0 0 .185 1.217.223 1.656 0 0 .036.223.364.601 0 0 .662.916.744 1.096 0 0 .157.319-.177.361 0 0-.61.06-.667.07 0 0-.142.006-.136.168 0 0-.032 2.116-.19 3.133 0 0-.04.403-.268.393 0 0-.625-.02-.77-.016 0 0-.063.005-.053-.082 0 0 .317-3.3.101-4.97 0 0-.008-.215-.176-.26 0 0-.15-.06-.297.137 0 0-.991 1.24-.99 2.975 0 0-.018.528.064.663 0 0 .05.092.309.113l.328.043s.061.002.056.079c0 0-.074.97-.096 1.14 0 0-.004.076-.025.115 0 0-.012.032-.115.028 0 0-1.446-.01-1.608-.003 0 0-.068.008-.083-.034-.014-.04-.1-1.25-.098-1.422 0 0-.004-.062.05-.085.068-.029.347-.232.402-.629 0 0 .021-.1.008-.553 0 0 .053-1.857.067-2.155 0 0 .011-.1-.122-.12 0 0-.13-.024-.15.102 0 0-.095 1.225-.076 1.712 0 0 .032.318-.19.323 0 0-.217.033-.227-.231 0 0 .015-1.192.068-1.78 0 0 .008-.103-.119-.127 0 0-.13-.026-.154.117 0 0-.094 1.14-.074 1.74 0 0 .028.292-.209.282 0 0-.197.023-.208-.237 0 0 .054-1.63.068-1.757 0 0 .012-.134-.13-.146 0 0-.127-.016-.143.121 0 0-.089 1.95-.074 2.522 0 0-.008.59.434.829 0 0 .064.036.066.093 0 0 .05 1.034.095 1.368 0 0 .017.08-.056.08 0 0-.943.024-1.111.03 0 0-.184.012-.224-.213-.037-.209-.24-1.938-.207-3.304 0 0 .012-.156-.135-.18 0 0-.569-.052-.706-.086 0 0-.265-.074-.145-.343 0 0 1.234-2.298 3.787-3.856",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "tenbisCardIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.281 3.334h8.438v8.333H9.281z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTenbisCardIcon);
export default ForwardRef;